/**
 * API配置文件
 * 集中管理所有API地址
 */

// API基础地址
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://elevator-backend-worker.lnhyaz2020.workers.dev';

// API端点
export const ENDPOINTS = {
    // 字段配置相关
    fields: '/api/fields',
    fieldMigrate: (name) => `/api/fields/${name}/migrate`,

    // 电梯数据相关
    elevators: '/api/elevators',
    elevator: (id) => `/api/elevators/${id}`,
    batchImport: '/api/elevators/batch-import',
};

/**
 * 构建完整的API URL
 */
export const buildUrl = (endpoint) => {
    return `${API_BASE_URL}${endpoint}`;
};

const config = {
    API_BASE_URL,
    ENDPOINTS,
    buildUrl
};

export default config;
